import Ic_download_primary from "../../../assets/images/Ic_download_primary.svg";
import React from "react";
import { formatCurrency } from "../../../lib/utils";
import FileInfo from "../../../components/FileInfo";
import { getDownloadURL, getStorage, ref } from "firebase/storage";
import Ic_file from "../../../assets/images/Ic_file.svg";
import Plantegninger from "./Plantegninger";
import { HouseImages } from "./houseImages";

const handleDownload = async (filePath: string) => {
  try {
    if (!filePath) {
      console.error("File path is missing!");
      return;
    }

    const storage = getStorage();
    const fileRef = ref(storage, filePath);
    const url = await getDownloadURL(fileRef);

    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.download = filePath.split("/").pop() || "download";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};
export const Husdetaljer: React.FC<{ husmodellData: any; loading: any }> = ({
  husmodellData,
  loading,
}) => {
  const getEmbedUrl = (url: string) => {
    const videoId = url.split("v=")[1]?.split("&")[0];
    return videoId
      ? `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1&controls=0&disablekb=1&fs=0`
      : "";
  };

  return (
    <>
      <div className="flex flex-col md:flex-row gap-4 md:gap-6 md:h-[333px] mb-6 md:mb-9 desktop:mb-[74px]">
        {loading ? (
          <div
            className="w-full md:w-2/3 h-full rounded-md custom-shimmer"
            style={{ borderRadius: "8px" }}
          ></div>
        ) : (
          <div className="w-full md:w-2/3 h-full">
            <h4 className="mb-2 md:mb-4 text-darkBlack text-sm md:text-base desktop:text-lg font-semibold">
              Illustrasjoner
            </h4>
            <div className="h-[calc(100%-40px)]">
              <HouseImages husmodellData={husmodellData} />
            </div>
          </div>
        )}
        {loading ? (
          <div
            className="w-full md:w-1/3 h-full rounded-md custom-shimmer"
            style={{ borderRadius: "8px" }}
          ></div>
        ) : (
          <div className="w-full md:w-1/3 border border-gray2 shadow-shadow2 rounded-lg h-full">
            <div className="px-3 md:px-4 py-3 md:py-5 border-b border-gray2 text-darkBlack text-sm md:text-base font-semibold">
              Dokumenter
            </div>
            <div className="p-3 md:p-4 flex flex-col gap-4 overflow-y-auto h-[calc(100%-65px)] overFlowAutoY">
              {husmodellData?.documents &&
              husmodellData?.documents.length > 0 ? (
                husmodellData?.documents.map((doc: any, index: number) => {
                  return (
                    <div
                      className="border border-gray3 rounded-lg p-2 md:p-3 flex items-center justify-between relative w-full"
                      key={index}
                    >
                      <div className="flex items-start gap-2 md:gap-4 truncate">
                        <div className="bg-lightGreen w-10 h-10 rounded-full flex justify-center items-center">
                          <img src={Ic_file} alt="file" />
                        </div>
                        <FileInfo file={doc} />
                      </div>
                      <div className="flex items-center gap-2 sm:gap-3 md:gap-4">
                        <div
                          className="cursor-pointer"
                          onClick={() => handleDownload(doc)}
                        >
                          <img src={Ic_download_primary} alt="download" />
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <>
                  <p>Ingen dokument funnet.</p>
                </>
              )}
            </div>
          </div>
        )}
      </div>
      <div className="w-full flex flex-col md:flex-row gap-6 lg:gap-[60px] mt-8">
        <div className="w-full md:w-[43%]">
          {loading ? (
            <div
              className="w-[300px] h-[30px] rounded-md custom-shimmer mb-6"
              style={{ borderRadius: "8px" }}
            ></div>
          ) : (
            <h4 className="text-darkBlack mb-4 md:mb-6 font-semibold text-lg md:text-xl desktop:text-2xl">
              {husmodellData?.husmodell_name}
            </h4>
          )}
          <div className="relative">
            {loading ? (
              <div
                className="w-full h-[262px] rounded-md custom-shimme"
                style={{ borderRadius: "8px" }}
              ></div>
            ) : (
              <img
                src={husmodellData?.photo}
                alt="product-1"
                className="w-full h-[262px] object-cover rounded-[12px] overflow-hidden"
              />
            )}
          </div>
          <div className="my-4 md:my-5 flex items-center justify-between gap-1">
            <div className="flex flex-col gap-2">
              <p className="text-gray text-sm md:text-base">Pris fra</p>
              {loading ? (
                <div
                  className="w-[300px] h-[30px] rounded-md custom-shimmer"
                  style={{ borderRadius: "8px" }}
                ></div>
              ) : (
                <h4 className="text-base md:text-lg desktop:text-xl font-semibold text-darkBlack">
                  {husmodellData?.pris && formatCurrency(husmodellData?.pris)}
                </h4>
              )}
            </div>
            <div className="flex items-center gap-2 md:gap-4">
              {loading ? (
                <div
                  className="w-[300px] h-[30px] rounded-md custom-shimmer"
                  style={{ borderRadius: "8px" }}
                ></div>
              ) : (
                <div className="text-gray text-xs md:text-sm">
                  <span className="text-darkBlack font-semibold">
                    {husmodellData?.BRATotal}
                  </span>{" "}
                  m<sup>2</sup>
                </div>
              )}
              <div className="h-[12px] w-[1px] border-l border-gray"></div>
              {loading ? (
                <div
                  className="w-[300px] h-[30px] rounded-md custom-shimmer"
                  style={{ borderRadius: "8px" }}
                ></div>
              ) : (
                <div className="text-gray text-xs md:text-sm">
                  <span className="text-darkBlack font-semibold">
                    {husmodellData?.Soverom}
                  </span>{" "}
                  soverom
                </div>
              )}
              <div className="h-[12px] w-[1px] border-l border-gray"></div>
              {loading ? (
                <div
                  className="w-[300px] h-[30px] rounded-md custom-shimmer"
                  style={{ borderRadius: "8px" }}
                ></div>
              ) : (
                <div className="text-gray text-xs md:text-sm">
                  <span className="text-darkBlack font-semibold">
                    {husmodellData?.Bad}
                  </span>{" "}
                  bad
                </div>
              )}
            </div>
          </div>
          <div className="w-full flex flex-col sm:flex-row gap-4 md:flex-col lg:flex-row lg:gap-8 mb-8 md:mb-[60px]">
            <div className="w-full lg:w-1/2 border-t-2 border-b-0 border-l-0 border-r-0 border-primary pt-3 md:pt-4">
              <table className="table-auto border-0 w-full text-left property_detail_tbl">
                <tbody>
                  <tr>
                    <td className="text-left pb-3 md:pb-4 text-gray text-sm whitespace-nowrap">
                      BRA total (bruksareal)
                    </td>
                    {loading ? (
                      <div
                        className="w-[300px] h-[30px] rounded-md custom-shimmer"
                        style={{ borderRadius: "8px" }}
                      ></div>
                    ) : (
                      <td className="text-left pb-3 md:pb-4 text-darkBlack text-sm font-semibold whitespace-nowrap">
                        {husmodellData?.BRATotal} m<sup>2</sup>
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td className="text-left pb-3 md:pb-4 text-gray text-sm whitespace-nowrap">
                      BRA bolig
                    </td>
                    {loading ? (
                      <div
                        className="w-[300px] h-[30px] rounded-md custom-shimmer"
                        style={{ borderRadius: "8px" }}
                      ></div>
                    ) : (
                      <td className="text-left pb-3 md:pb-4 text-darkBlack text-sm font-semibold whitespace-nowrap">
                        {husmodellData?.BebygdAreal} m<sup>2</sup>
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td className="text-left pb-3 md:pb-4 text-gray text-sm whitespace-nowrap">
                      GUA (Gulvareal):
                    </td>
                    {loading ? (
                      <div
                        className="w-[300px] h-[30px] rounded-md custom-shimmer"
                        style={{ borderRadius: "8px" }}
                      ></div>
                    ) : (
                      <td className="text-left pb-3 md:pb-4 text-darkBlack text-sm font-semibold whitespace-nowrap">
                        {husmodellData?.PRom} m<sup>2</sup>
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td className="text-left pb-3 md:pb-4 text-gray text-sm whitespace-nowrap">
                      Bebygd areal (BYA)
                    </td>
                    {loading ? (
                      <div
                        className="w-[300px] h-[30px] rounded-md custom-shimmer"
                        style={{ borderRadius: "8px" }}
                      ></div>
                    ) : (
                      <td className="text-left pb-3 md:pb-4 text-darkBlack text-sm font-semibold whitespace-nowrap">
                        {husmodellData?.BebygdAreal} m<sup>2</sup>
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td className="text-left pb-3 md:pb-4 text-gray text-sm whitespace-nowrap">
                      Lengde
                    </td>
                    {loading ? (
                      <div
                        className="w-[300px] h-[30px] rounded-md custom-shimmer"
                        style={{ borderRadius: "8px" }}
                      ></div>
                    ) : (
                      <td className="text-left pb-3 md:pb-4 text-darkBlack text-sm font-semibold whitespace-nowrap">
                        {husmodellData?.Lengde}
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td className="text-left pb-3 md:pb-4 text-gray text-sm whitespace-nowrap">
                      Bredde
                    </td>
                    {loading ? (
                      <div
                        className="w-[300px] h-[30px] rounded-md custom-shimmer"
                        style={{ borderRadius: "8px" }}
                      ></div>
                    ) : (
                      <td className="text-left pb-3 md:pb-4 text-darkBlack text-sm font-semibold whitespace-nowrap">
                        {husmodellData?.Bredde}
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td className="text-left pb-3 md:pb-4 text-gray text-sm whitespace-nowrap">
                      Soverom
                    </td>
                    {loading ? (
                      <div
                        className="w-[300px] h-[30px] rounded-md custom-shimmer"
                        style={{ borderRadius: "8px" }}
                      ></div>
                    ) : (
                      <td className="text-left pb-3 md:pb-4 text-darkBlack text-sm font-semibold whitespace-nowrap">
                        {husmodellData?.Soverom}
                      </td>
                    )}
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="w-full lg:w-1/2 border-t-2 border-b-0 border-l-0 border-r-0 border-primary pt-3 md:pt-4">
              <table className="table-auto border-0 w-full text-left property_detail_tbl">
                <tbody>
                  <tr>
                    <td className="text-left pb-3 md:pb-4 text-gray text-sm whitespace-nowrap">
                      Bad
                    </td>
                    {loading ? (
                      <div
                        className="w-[300px] h-[30px] rounded-md custom-shimmer"
                        style={{ borderRadius: "8px" }}
                      ></div>
                    ) : (
                      <td className="text-left pb-3 md:pb-4 text-darkBlack text-sm font-semibold whitespace-nowrap">
                        {husmodellData?.Bad}
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td className="text-left pb-3 md:pb-4 text-gray text-sm whitespace-nowrap">
                      Innvendig bod
                    </td>
                    {loading ? (
                      <div
                        className="w-[300px] h-[30px] rounded-md custom-shimmer"
                        style={{ borderRadius: "8px" }}
                      ></div>
                    ) : (
                      <td className="text-left pb-3 md:pb-4 text-darkBlack text-sm font-semibold whitespace-nowrap">
                        {husmodellData?.InnvendigBod}
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td className="text-left pb-3 md:pb-4 text-gray text-sm whitespace-nowrap">
                      Energimerking
                    </td>
                    {loading ? (
                      <div
                        className="w-[300px] h-[30px] rounded-md custom-shimmer"
                        style={{ borderRadius: "8px" }}
                      ></div>
                    ) : (
                      <td className="text-left pb-3 md:pb-4 text-darkBlack text-sm font-semibold whitespace-nowrap">
                        {husmodellData?.Energimerking}
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td className="text-left pb-3 md:pb-4 text-gray text-sm whitespace-nowrap">
                      Tilgjengelig bolig
                    </td>
                    {loading ? (
                      <div
                        className="w-[300px] h-[30px] rounded-md custom-shimmer"
                        style={{ borderRadius: "8px" }}
                      ></div>
                    ) : (
                      <td className="text-left pb-3 md:pb-4 text-darkBlack text-sm font-semibold whitespace-nowrap">
                        {husmodellData?.TilgjengeligBolig}
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td className="text-left pb-3 md:pb-4 text-gray text-sm whitespace-nowrap">
                      Tomtetype
                    </td>
                    {loading ? (
                      <div
                        className="w-[300px] h-[30px] rounded-md custom-shimmer"
                        style={{ borderRadius: "8px" }}
                      ></div>
                    ) : (
                      <td className="text-left pb-3 md:pb-4 text-darkBlack text-sm font-semibold whitespace-nowrap">
                        {Array.isArray(husmodellData?.Tomtetype)
                          ? husmodellData.Tomtetype.join(", ")
                          : husmodellData?.Tomtetype}
                      </td>
                    )}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <h2 className="mb-6 text-darkBlack text-lg md:text-xl desktop:text-2xl font-semibold">
            Plantegninger og fasader
          </h2>
          {loading ? (
            <div
              className="w-full h-[300px] rounded-md custom-shimmer"
              style={{ borderRadius: "8px" }}
            ></div>
          ) : (
            <Plantegninger loading={loading} husmodellData={husmodellData} />
          )}
        </div>
        <div className="w-full md:w-[57%]">
          {loading ? (
            <div
              className="w-[300px] h-[30px] rounded-md custom-shimmer mb-4"
              style={{ borderRadius: "8px" }}
            ></div>
          ) : (
            <h2 className="text-darkBlack text-lg md:text-xl desktop:text-2xl font-semibold mb-2 md:mb-4 truncate">
              {husmodellData?.Hustittel}
            </h2>
          )}
          <div className="flex flex-col gap-4 mb-8 md:mb-[60px]">
            {loading ? (
              <div
                className="w-full h-[100px] rounded-md custom-shimmer"
                style={{ borderRadius: "8px" }}
              ></div>
            ) : (
              <p className="text-sm md:text-base text-gray h-full focus-within:outline-none resize-none">
                {husmodellData?.OmHusmodellen}
              </p>
            )}
          </div>
          {loading ? (
            <div
              className="w-[300px] h-[30px] rounded-md custom-shimmer mb-4"
              style={{ borderRadius: "8px" }}
            ></div>
          ) : (
            <h2 className="text-darkBlack text-lg md:text-xl desktop:text-2xl font-semibold mb-4">
              {husmodellData?.TittelVideo}
            </h2>
          )}

          {husmodellData?.VideoLink && (
            <div
              style={{
                width: "100%",
                height: "400px",
              }}
            >
              {loading ? (
                <div
                  className="w-full h-[30px] rounded-md custom-shimmer"
                  style={{ borderRadius: "8px" }}
                ></div>
              ) : (
                <iframe
                  width="100%"
                  height="100%"
                  src={getEmbedUrl(husmodellData?.VideoLink)}
                  frameBorder="0"
                  allowFullScreen
                  title={husmodellData?.TittelVideo}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                ></iframe>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};
